import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { User, Star, Users, BookOpen, Copy, Share2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const TeacherProfilePage = () => {
  const { teacherId } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/api/teacher/profile/${teacherId}`)
      .then(res => { setProfile(res.data); setLoading(false); })
      .catch(() => { setLoading(false); });
  }, [teacherId]);

  if (loading) return <div className="min-h-screen bg-[#0B1A2A] flex items-center justify-center"><div className="text-white text-lg">Loading...</div></div>;
  if (!profile) return <div className="min-h-screen bg-[#0B1A2A] flex items-center justify-center"><div className="text-white text-lg">Teacher not found</div></div>;

  const profileUrl = window.location.href;

  return (
    <div className="min-h-screen bg-[#0B1A2A] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-slate-800/60 rounded-2xl border border-slate-700 overflow-hidden backdrop-blur-sm" data-testid="teacher-public-profile">
          <div className="bg-gradient-to-r from-[#3B82F6] to-indigo-600 p-8 text-center">
            <div className="w-24 h-24 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-4 overflow-hidden border-3 border-white/30">
              {profile.profile_photo ? (
                <img src={profile.profile_photo.startsWith('/') ? `${API}${profile.profile_photo}` : profile.profile_photo} alt="" className="w-full h-full object-cover" />
              ) : (
                <User className="w-12 h-12 text-white" />
              )}
            </div>
            <h1 className="text-2xl font-bold text-white" data-testid="profile-name">{profile.name}</h1>
            <p className="text-blue-200 text-sm mt-1">CodeITT Academy Teacher</p>
          </div>
          <div className="p-6 space-y-4">
            <div className="grid grid-cols-3 gap-3">
              <div className="text-center p-3 bg-amber-500/10 rounded-xl border border-amber-500/30">
                <div className="flex items-center justify-center gap-1"><Star className="w-4 h-4 text-amber-400" /><span className="text-xl font-bold text-white">{profile.avg_rating || '—'}</span></div>
                <p className="text-xs text-slate-400 mt-1">Rating</p>
              </div>
              <div className="text-center p-3 bg-[#3B82F6]/10 rounded-xl border border-[#3B82F6]/30">
                <div className="flex items-center justify-center gap-1"><Users className="w-4 h-4 text-[#3B82F6]" /><span className="text-xl font-bold text-white">{profile.student_count}</span></div>
                <p className="text-xs text-slate-400 mt-1">Students</p>
              </div>
              <div className="text-center p-3 bg-emerald-500/10 rounded-xl border border-emerald-500/30">
                <div className="flex items-center justify-center gap-1"><BookOpen className="w-4 h-4 text-emerald-400" /><span className="text-xl font-bold text-white">{profile.review_count}</span></div>
                <p className="text-xs text-slate-400 mt-1">Reviews</p>
              </div>
            </div>
            {profile.bio && (
              <div className="bg-slate-800/40 rounded-xl p-4 border border-slate-700">
                <p className="text-sm text-slate-300">{profile.bio}</p>
              </div>
            )}
            {profile.specializations?.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {profile.specializations.map((s, i) => <span key={i} className="px-3 py-1 bg-[#3B82F6]/10 text-[#3B82F6] rounded-full text-xs font-bold border border-[#3B82F6]/30">{s}</span>)}
              </div>
            )}
            <div className="pt-3 border-t border-slate-700">
              <Button className="w-full bg-[#3B82F6] hover:bg-blue-600 text-white font-bold"
                onClick={() => { navigator.clipboard.writeText(profileUrl); toast.success('Profile link copied!'); }}
                data-testid="share-profile-btn">
                <Copy className="w-4 h-4 mr-2" /> Share Profile
              </Button>
            </div>
          </div>
        </div>
        <div className="text-center mt-4">
          <a href="/" className="text-sm text-slate-400 hover:text-white transition-colors">Powered by CodeITT Academy</a>
        </div>
      </div>
    </div>
  );
};

export default TeacherProfilePage;
